import { useQuery } from "react-query";
import { useRouter } from "../../useRouter";
import { useApiError } from "src/hooks/useApiError";
import { useState } from "react";
import { getMyServiceList } from "src/service/console";
import { getProductFromSessionStorage } from "src/utils/storage/auth";
import { IGetMyServiceListRes } from "src/service/types/console.type";
import { productKeyAtom, serviceNoAtom, userInfoAtom } from "src/atoms";
import { useRecoilState } from "recoil";

interface IUseGetMyServiceListProps {
  anyProps?: any;
}
// 가입된 서비스 정보
export function useGetMyServiceList({ anyProps }: IUseGetMyServiceListProps) {
  const { handleError } = useApiError();
  const route = useRouter();
  const [serviceNo] = useRecoilState(serviceNoAtom);
  const [productKey, setProductKey] = useRecoilState(productKeyAtom);
  const [userInfo, setUserInfo] = useRecoilState(userInfoAtom);

  const product = getProductFromSessionStorage();

  const isReady =
    !!product && !!userInfo?.userName;

  const query = useQuery<IGetMyServiceListRes[]>(
    ["getMyServiceList", product],
    () => getMyServiceList({ product }),
    {
      enabled: isReady,
      // refetch 관련 옵션 제거 (선택)
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      onError: handleError,
    }
  );

  return {
    isMyServiceLoading: query.isLoading,
    serviceList: query.data ?? [],
  };
}
